(function () {
  'use strict';

  var KEY = 'fraire-animations';
  var LABEL_ON = 'Animation aus — want to feel the heat?';
  var LABEL_OFF = 'Animation an — want to feel the heat?';
  var bound = false;

  function readStoredOn() {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeStoredOn(on) {
    try {
      localStorage.setItem(KEY, on ? '1' : '0');
    } catch (e) {}
  }

  function isOn() {
    return document.documentElement.classList.contains('fraire-animations-on');
  }

  function isIndexPage() {
    return document.body && document.body.classList.contains('fraire-lava-page');
  }

  function setUiState(on) {
    document.documentElement.classList.toggle('fraire-animations-on', !!on);
    document.querySelectorAll('.fraire-heat-toggle').forEach(function (root) {
      root.classList.toggle('is-animations-on', !!on);
    });
    document.querySelectorAll('.fraire-heat-toggle__btn').forEach(function (trigger) {
      trigger.setAttribute('aria-checked', on ? 'true' : 'false');
      trigger.setAttribute('aria-pressed', on ? 'true' : 'false');
      trigger.setAttribute('aria-label', on ? LABEL_ON : LABEL_OFF);
    });
  }

  function notify(on) {
    window.dispatchEvent(new CustomEvent('fraire:animations', { detail: { on: !!on } }));
  }

  function syncPageLayout() {
    window.requestAnimationFrame(function () {
      if (window.fraireHeroLava && window.fraireHeroLava.resize) {
        window.fraireHeroLava.resize(true);
        window.fraireHeroLava.redraw();
      }
      window.dispatchEvent(
        new CustomEvent('fraire:layout-sync', {
          detail: { scrollY: window.scrollY || window.pageYOffset || 0 },
        })
      );
    });
  }

  function whenHeroReady(fn) {
    if (window.__fraireHeroReady) {
      fn();
      return;
    }
    window.addEventListener('fraire:hero-ready', fn, { once: true });
    // Fallback if hero-ready never fires (slow GL / missing hero section).
    window.setTimeout(function () {
      if (!window.__fraireHeroReady) {
        window.__fraireHeroReady = true;
        fn();
      }
    }, 2500);
  }

  function applyMountState(on) {
    if (!isIndexPage()) return;

    var lava = document.getElementById('fraire-lava');
    var mount = document.getElementById('fraire-lava-mount');

    if (on) {
      if (lava) lava.style.display = 'block';
      if (mount) {
        mount.style.display = '';
        mount.style.opacity = '1';
      }
      if (window.fraireHeroLavaController && window.fraireHeroLavaController.mountAnimated) {
        window.fraireHeroLavaController.mountAnimated();
      }
      syncPageLayout();
      return;
    }

    if (window.fraireHeroLavaController) {
      if (window.fraireHeroLavaController.snapshotThenRelease) {
        window.fraireHeroLavaController.snapshotThenRelease(syncPageLayout);
      } else if (window.fraireHeroLavaController.ensureStatic) {
        window.fraireHeroLavaController.ensureStatic(syncPageLayout);
      }
    }
  }

  function setOn(on) {
    on = !!on;
    writeStoredOn(on);
    setUiState(on);
    notify(on);

    if (!isIndexPage()) {
      syncPageLayout();
      return;
    }

    whenHeroReady(function () {
      // Re-read in case multiple toggles raced.
      applyMountState(readStoredOn());
    });
  }

  function toggle() {
    setOn(!isOn());
  }

  function onToggleClick(e) {
    var trigger = e.target && e.target.closest ? e.target.closest('.fraire-heat-toggle__btn') : null;
    if (!trigger) return;
    e.preventDefault();
    try {
      toggle();
    } catch (err) {
      console.error('[fraire] animation toggle failed', err);
    }
  }

  function init() {
    setUiState(readStoredOn());

    if (!bound) {
      bound = true;
      // Bubble phase — avoid fighting sticky-header / drawer capture handlers.
      document.addEventListener('click', onToggleClick);
    }

    if (isIndexPage()) {
      whenHeroReady(function () {
        applyMountState(readStoredOn());
      });
    }
  }

  window.FraireAnimations = {
    isOn: isOn,
    setOn: setOn,
    toggle: toggle,
    KEY: KEY,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
